import React from "react";
import { useSearchParams } from "react-router";
import clsx from "clsx";

import { useThemingPrefix } from "hooks/useThemingPrefix";

import { Center, Footer, Loading, SimpleHeader } from "../../components/ui";
import { appConfig } from "../../utils/constants";
import { getRoute, pages } from "../../utils/routrer-utils";
import { useGetAuthQuery } from "../../store/api/auth.api";
import { ConnectWithUs } from "../../components";

import styles from "./index.module.css";

const LoginPage = () => {
  const [search] = useSearchParams();
  const link = search.get("link");
  if (link !== null) localStorage.setItem(appConfig.AUTH_LINK, link);
  const vendorThemingPrefix = useThemingPrefix();
  const { data, isSuccess, isLoading, isError } = useGetAuthQuery(link);

  if (isSuccess && data.access_token) {
    setTimeout(
      () =>
        (window.location.href = getRoute(pages.VIDEOS, vendorThemingPrefix)),
      1000
    );
  }

  return (
    <>
      <SimpleHeader />
      <div className={styles.container}>
        <Center>
          {isLoading && <Loading title="Идёт авторизация…" />}
          {isSuccess && (
            <div className={styles.contentWrapper}>
              <div className={clsx(styles.loginBox, styles.successText)}>
                Успешная авторизация! Секунду...
              </div>
            </div>
          )}
          {isError && (
            <div className={styles.contentWrapper}>
              <div className={clsx(styles.loginBox, styles.errorText)}>
                Неверная ссылка для авторизации!
              </div>
              <ConnectWithUs />
            </div>
          )}
        </Center>
      </div>
      <Footer />
    </>
  );
};

export default LoginPage;
